export const legacyRoutes = {
  list: '/admin/erm-job',
  add: '/admin/erm-job/add',
  edit: '/admin/erm-job/:itemId',
  getEditLink: (itemId: string) => `/admin/erm-job/${itemId}`,
};
